<template>
	<div class="row" style="height: 100%">
		<div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 pr-0" id="left-panel" style="display: flex; flex-direction: column; background-color: transparent;">
			<div class="bg-dark-noise modal-topbar p-2" style="display: flex; flex-direction: row;">
				<div class="d-flex justify-content-start align-self-center">
					<div @click="$emit('close')" class="modal-button-sm modal-button--white"><i class="fas fa-times"></i></div>
				</div>
				<div class="d-flex justify-content-center align-self-center" style="flex-grow: 100;">
					<div class="modal-title text-white mx-2"><b>{{images.length}} {{ __('translations.images') }}</b></div>
				</div>
			</div>
			<div id="multiple-images-content">
				<table class="table table-light table-striped mb-0" style="width: 100%; table-layout: fixed;">
				  <tbody name="toggled-image" is="transition-group">
				    <tr v-for="(image, index) in images" :key="image.id">
				      <td scope="row" width="30%" class="p-3"><img :src="image.iiif_root + '/full/400,/0/default.jpg'" style="width: 100%;" alt=""></td>
				      <td class="p-3">
				      	<div class="card-title">
				      		<div style="font-size: 20px; line-height: 20px;">{{image.image_id}}</div>
				      		<div class="image-result__buttons" style="line-height: 20px; height: 20px; cursor: pointer;">
								<div class="button mark-toggle mark-toggle--active vtm-icon-M di" @click="removeImage(image.id, index)">
									<svg width="20px" height="15px" viewBox="0 0 20 15" version="1.1"
										xmlns="http://www.w3.org/2000/svg"
										xmlns:xlink="http://www.w3.org/1999/xlink">
					      				<desc>Star icon.</desc>
					      				<defs></defs>
					      				<g id="Star" stroke="none" stroke-width="1" fill="none"	fill-rule="evenodd">
					  						<g id="SVGcode" transform="translate(-1.000000, -1.000000)">
												<polygon id="bounds" points="0 16 22 16 22 0 0 0"></polygon>
												<polygon id="Star" stroke="#222222"	stroke-linecap="square" fill-rule="nonzero"	points="5.24513796 14.5584124 11 11.4065927 16.754862 14.5584124 14.5382505 9.47723972 20.0243553 6.50010718 13.254288 6.51121061 11 1.26623262 8.74571196 6.51121061 1.97564469 6.50010718 7.46174947 9.47723972"></polygon>
					  						</g>
					      				</g>
					      			</svg>
				      			</div>
			      			</div>
		      			</div>
		      			<p class="card-text">
			            	<span v-for="tag in image.tags" :key="'selected-tag-' + tag.id" class="badge badge-tag" :class="tag.class">
								{{tag.wikidata_label}}
							</span>
						</p>
				      </td>
				    </tr>
				  </tbody>
				</table>
			</div>
		</div>
		<div class="col-sm-0 col-md-0 col-lg-4 col-xl-4 pl-0" id="right-panel">
			<div class="wikidata-search-container">
				<div class="bg-light-noise modal-topbar pl-3 py-3">
					<b>{{ __('translations.title.wikidata_search') }}</b>
				</div>
				<div style="overflow: hidden;" class="p-3">
					<wikidata-search taggableType="image"
						v-on:selected-tag="onSelectedTag"
						v-on:deselected-tag="onDeselectedTag"
						:populateWith="tags"></wikidata-search>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'
import WikidataSearch from '../components/WikidataSearch'

export default {
	name: 'ImagesSelectedModal',
	props: ['images'],
	components: {
		'wikidata-search': WikidataSearch
	},
	data() {
		return {
			tags: [],
		}
	},
	computed: {
		...mapGetters([
			'selectedImageIds'
		])
	},
	methods: {
		onSelectedTag(tag) {
			this.tags.push(this.tagToDisplay(tag));
			
			axios.post('/multipleImages/tag/save', {ids: this.imageIds(), tag: tag}).then(response => {
				_.map(this.images, function(image) {
					var returnedTag = response.data[image.id];
					
					if(typeof returnedTag.added_tag !== 'undefined') {
						Vue.set(returnedTag.added_tag, 'class', 'tag-success');
						image.tags.push(returnedTag.added_tag);
						updateTagsCount(image);
					} else if (typeof returnedTag.existing_tag !== 'undefined') {
						var index = _.findKey(image.tags, ['wikidata_id', returnedTag.existing_tag.wikidata_id]);
						Vue.set(image.tags[index], 'class', 'tag-warning');
					}
				});
			}).catch(err => {
				console.log(err);
			})
		},
		onDeselectedTag(tag) {
			var index = _.findKey(this.tags, ['wikidata_id', tag.wikidata_id]);
			this.tags.splice(index, 1);
			
			axios.post('/multipleImages/tag/delete', {ids: this.imageIds(), tag: tag}).then(response => {
				_.map(this.images, function(image) {
					var index = _.findKey(image.tags, ['wikidata_id', tag.wikidata_id]);
					Vue.set(image.tags[index], 'class', 'tag-danger');
					
					setTimeout(function () {
						image.tags.splice(index, 1);
						updateTagsCount(image);
					}, 600);
				});
			}).catch(err => {
				console.log(err)
			})
		},
		imageIds() {
			return _.map(this.images, 'id');
		},
		tagToDisplay(tag) {
			return {
				'wikidata_id': tag.id,
				'wikidata_label': tag.label,
				'wikidata_desc': tag.description
			}
		},
		removeImage(imageId, index) {
			this.$store.commit('REMOVE_FROM_SELECTED_IMAGE_IDS', imageId);
			
			this.images.splice(index, 1);
			
			// If no images left, close the modal.
			if(this.images.length === 0) {
				var self = this;
				setTimeout(function () {
					self.$emit('close');
				}, 400);
			}
		}
	}
}
</script>